import React from 'react';
import './ScorecardIcons.styl';
import classNames from 'classnames';

let ReasonIcon = require('images/card/ReasonBulb.png');

const BulbIcon = ({shrink = false}) => (
  <div className="scorecard-img-wrapper">
    <img src={ReasonIcon} alt="Add Reason" className={classNames('bulb', {shrink})} />
  </div>
);

export default BulbIcon;
